<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Sales Commission Payout"
            />
        </div>
        <div class="mt-2 px-2">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
              <div class="mb-1">
                <label for="colFormLabel" class="col-form-label">Month</label>
                <vField
                    v-model="month"
                    name="month"
                    id="month"
                    type="month"
                    class="form-control"
                />
              </div>
            </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
            <div class="mb-1">
              <label for="colFormLabel" class="col-form-label">Staff Id</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  placeholder="Enter Staff Id"
                  v-model="staffId"
              >
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1 mt-2">
            <button
                style="min-width: 64px;"
                @click="onClickToGo"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            > Go
            </button>
          </div>
        </div>
        </div>
      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="onClickToPrint"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
          >
            Print
          </button>
        </div>
      </div>

        <div class="px-2" v-if="tableItems.length">
          <div class="row summary-row">
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-opening">
                <p class="stat-label">Total Sales Submission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.sale_allocation_amount) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-debit">
                <p class="stat-label">Personal Sale Commission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.personal_sale_amount) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-credit">
                <p class="stat-label">Group Sale Commission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.group_sale_commission) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-closing">
                <p class="stat-label">BP Commission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.group_bp_commission) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-total">
                <p class="stat-label">Total Commission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.total_sale_commission) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-payout">
                <p class="stat-label">Payout Percentage</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.payout_percentage) }}%</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-service-charge">
                <p class="stat-label">Service Charge</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.service_charge) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-net-commission">
                <p class="stat-label">Net Commission</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.net_commission) }}</h4>
              </div>
            </div>
            <div class="col-md-4 col-lg-2 col-12 py-1">
              <div class="stat-tile border-payout-without-service-charge">
                <p class="stat-label">Payout Percentage (Without Service Charge)</p>
                <h4 class="stat-value">{{ commaFormat(totalValue.payout_percentage_without_service_charge) }}%</h4>
              </div>
            </div>
            <template v-if="incentiveSetupWise.length">
              <div class="col-md-3 col-lg-2 col-12 py-1" v-for="(item, i) in incentiveSetupWise" :key="i">
                <div class="stat-tile border-incentive-setup">
                  <p class="stat-label">{{ item.level_name }}({{ item.equivalent_designation }})</p>
                  <h4 class="stat-value">{{ commaFormat(item.payout_percentage) }}%</h4>
                  <p class="stat-label">Commission: {{ commaFormat(item.total_sale_commission) }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="col-12">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-center">Staff ID</th>
                  <th class="text-center">Staff Name</th>
                  <th class="text-center">Designation</th>
                  <th class="text-center">Ref ID</th>
                  <th class="text-right">Sales Amount</th>
                  <th class="text-right">Personal Sales Commission</th>
                  <th class="text-right">Group Sales Commission</th>
                  <th class="text-center">Company Sales Share</th>
                  <th class="text-right">BP Commission</th>
                  <th class="text-right">Total Commission</th>
                  <th class="text-right">Service Charge</th>
                  <th class="text-right">Net Commission</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td>{{ item.serial_no }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.level_name }}({{ item.equivalent_designation }})</td>
                  <td>{{ item.parent_serial_no }}</td>
                  <td class="text-right">{{ commaFormat(item.allocated_sales_amount) }}</td>
                  <td class="text-right">{{ commaFormat(item.personal_sale_amount) }}</td>
                  <td class="text-right">{{ commaFormat(item.group_sale_commission) }}</td>
                  <td class="text-right">{{ commaFormat(item.company_sale_share) }}</td>
                  <td class="text-right">{{ commaFormat(item.group_bp_commission) }}</td>
                  <td class="text-right">{{ commaFormat(item.total_sale_commission) }}</td>
                  <td class="text-right">{{ commaFormat(item.service_charge) }}</td>
                  <td class="text-right">{{ commaFormat(item.net_commission) }}</td>
                </tr>
                 <tr v-if="tableItems.length < 1">
                   <td colspan="12" class="text-center">No Data found</td>
                 </tr>
                </tbody>
              </table>

              <div class="px-2 pt-2">
                <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
              </div>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleSdm from "@/services/modules/sdm/sdm";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import saleCommissionPayoutPdf from '@/services/utils/pdf/saleCommissionPayoutPdf';
import figureFormatter from "@/services/utils/figureFormatter";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const totalValue = ref({});
const incentiveSetupWise = ref([]);
const staffId = ref(null);
const month = ref(null);
const { fetchCompanyInfo } = handleCompany();
let companyInfo = reactive({})
const { exportToPDF } = saleCommissionPayoutPdf();
const token = computed(() => localStorage.getItem('token'));
const { commaFormat } = figureFormatter();

const {
  fetchSaleCommissionPayoutData
} = handleSdm()
let offset = ref(20)

const onClickToGo = () => {
  getSaleCommissionData();
}

async function onClickToPrint() {
  let query = getQuery();
  query += `&is_all=1`;

  let tableItemData;
  let totalValueData;
  let incentiveSetupWiseData;
  await fetchSaleCommissionPayoutData(query).then((res) => {
    if (! res.status) {
      showError(res.message)
      return
    }
    tableItemData = res.data.data;
    totalValueData = res.data.total
    incentiveSetupWiseData = res.data.incentive_setup_wise
  }).then(() => {
    exportToPDF(companyInfo, tableItemData, totalValueData, month.value, incentiveSetupWiseData)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getSaleCommissionData();
}

const getSaleCommissionData = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []
    incentiveSetupWise.value = []

    await fetchSaleCommissionPayoutData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }
        tableItems.value = res.data.data.data;
        totalValue.value = res.data.total
        incentiveSetupWise.value = res.data.incentive_setup_wise
        setPagination(res.data.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (staffId.value) query += '&staff_id=' + staffId.value;
    if (month.value) query += '&month=' + month.value;
    if (route.query.page) query += '&page=' + route.query.page;
    query += '&offset='+offset.value
    return query;
}

onMounted(() => {
  setCompanyInfo()
});

</script>

<style scoped>
.head td {
  text-align: right;
}
.stat-tile {
  position: relative;
  height: 100%;
  min-height: 92px;
  padding: 14px 16px;
  border: 1px solid #d8d6e0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.stat-tile:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(34, 41, 47, 0.14);
}
.stat-label {
  margin-bottom: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6e6b7b;
  letter-spacing: 0.2px;
}
.stat-value {
  margin-bottom: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #2f2b3d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 576px) {
  .stat-value {
    font-size: 1.1rem;
  }
  .stat-tile {
    min-height: 80px;
  }
}
.border-opening {
  border-color: #00cfe8;
}
.border-debit {
  border-color: #7367f0;
}
.border-credit {
  border-color: #28c76f;
}
.border-closing {
  border-color: #ea5455;
}
.border-total {
  border-color: #5e50ee;
}
.border-payout {
  border-color: #ff9f43;
}
.border-service-charge {
  border-color: #ea7c69;
}
.border-net-commission {
  border-color: #1e9ff2;
}
.border-payout-without-service-charge {
  border-color: #82868b;
}
.border-incentive-setup {
  border-color: #a8b545;
}
</style>